/** 订单详情
 * 有user_id则直接使用user_id, 没有则需要登录
 * **/

import './index.less';
import React, {useEffect, useState} from 'react';
import {convertPrice} from '@utils/tools';
import {mapDealStateText, convertGender, VIDEO_SUPPORT_MAP} from '@utils/public';
import ListItem from '@comp/ListItem';
import BackHeader from '@comp/BackHeader';
import queryString from 'query-string';
import {fetchDeal, reqCancelDeal} from '@/store/api/deal';
import {Modal, Button, Toast} from 'antd-mobile-v2';
import dayjs from 'dayjs';

function DealDetail(props) {
  console.log('props:', props);
  const [dealData, setDealData] = useState({});
  const {user_id, ref} = queryString.parse(props.location.search);
  const {id} = props.match.params;
  useEffect(() => {
    document.title = '固生堂 - 订单详情';
    updateDeal({deal_id: id, user_id});
  }, [id, user_id]);

  const updateDeal = ({deal_id, user_id}) => {
    fetchDeal({deal_id, user_id}).then(json => {
      if (json.isOK) {
        setDealData(json);
      } else {
        Modal.alert('错误', `[${json.status}] ${json.message || json.detail}`);
      }
    });
  };

  const onClickCancel = e => {
    console.log(`订单id, ${id}, 用户id: ${user_id}`);
    Modal.alert('取消订单', '您确定要取消订单吗？', [
      {text: '放弃', onPress: () => console.log('cancel')},
      {
        text: '取消订单',
        onPress: () => {
          let oParam = {
            deal_id: id,
            user_id,
            cancel_reason: '平安膏方好福利取消',
          };
          Toast.loading('取消中...', 0);
          reqCancelDeal(oParam).then(res => {
            if (res.isOK) {
              Toast.success('取消成功', 3, () => {
                updateDeal({deal_id: id, user_id});
              });
            } else {
              Toast.fail(res.message);
            }
          });
        },
      },
    ]);
  };

  const deal_state_text = mapDealStateText(dealData.deal_state, dealData.video);
  const clinicAddress =
    dealData.video === '3'
      ? [
          {label: '就诊医院', text: dealData.clinic_name},
          {label: '就诊地址', text: dealData.clinic_address},
        ]
      : [];
  const clinicInfo = [
    {label: '就诊医生', text: dealData.doctor_name},
    {label: '就诊科室', text: dealData.department_name},
    ...clinicAddress,
    {label: '就诊时间', text: dayjs.unix(dealData.reservation_start_time).format('YYYY-MM-DD HH:mm')},
    {label: '就诊方式', text: VIDEO_SUPPORT_MAP[dealData.video]},
  ];
  const patientInfo = [
    {label: '就诊人', text: dealData.patient_name},
    {label: '性别', text: convertGender(dealData.patient_sex)},
    {label: '生日', text: dealData.patient_birth},
    {label: '预约手机', text: dealData.patient_phone},
  ];
  const priceInfo = [
    {label: '订单金额', text: `¥ ${convertPrice(dealData.receivable_price)}`, txtType: 'after'},
    {label: '实付款', text: `¥ ${convertPrice(dealData.price)}`, txtType: 'after', txtClass: 'color-danger'},
  ];
  const canBeCancel = dealData.deal_type === '4' && !+dealData.cancel_time;

  return (
    <article className="page deal-detail">
      {ref && ref === 'pingan' ? null : <BackHeader title={'订单详情'} right={null} />}
      <section className="main">
        <div className="content-block-inner">
          <span>订单号：{id}</span>
          <span>{deal_state_text}</span>
        </div>
        <ListItem list={clinicInfo} />
        <ListItem list={patientInfo} />
        <ListItem list={priceInfo} className="price-list" />
      </section>
      {canBeCancel ? (
        <section className="footer">
          <Button className="action btn-cancel" onClick={onClickCancel}>
            取消预约
          </Button>
        </section>
      ) : null}
    </article>
  );
}

export default DealDetail;
